'use client';

import classNames from 'classnames';
import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import IconButton from '@alltrails/denali/components/IconButton';
import EditIcon from '@alltrails/denali/icons/Edit';
import TrailStatus from '@alltrails/types/TrailStatus';
import useTrailEditToolbar from '@/hooks/useTrailEditToolbar';
import layoutStyles from '../layouts/layoutStyles.module.scss';
import styles from './TrailHeader.module.scss';

type TrailHeaderProps = {
  trailName: string;
  trailStatus?: TrailStatus;
  variant?: ComponentProps<typeof Typography>['variant'];
  isAdminOrPLPUser?: boolean;
  seoTestH1?: string;
};

const TrailHeader = ({ trailName, trailStatus, isAdminOrPLPUser, seoTestH1 }: TrailHeaderProps) => {
  const displayName = trailStatus === TrailStatus.Pending ? `${trailName} [PENDING]` : trailName;
  const intl = useIntl();
  const { openTrailEditToolbar } = useTrailEditToolbar();

  return (
    <div className={layoutStyles.colLayout}>
      <h1 className={classNames(styles.header, { [styles.adminHeader]: isAdminOrPLPUser })}>
        {seoTestH1 ?? displayName}
        {isAdminOrPLPUser && (
          <IconButton
            icon={{ Component: EditIcon }}
            className={styles.editIcon}
            size="sm"
            variant="primary"
            onClick={() => openTrailEditToolbar('name')}
            title={intl.formatMessage({ defaultMessage: 'Edit' })}
          />
        )}
      </h1>
    </div>
  );
};

export default TrailHeader;
